<template>
  <section
    v-if="getValidUrl(slice?.Source)"
    class="ct-iframe"
  >
    <div class="ct-iframe__container container">
      <iframe
        class="ct-iframe__iframe iframe"
        :class="{
          'iframe--scale-horizontally': slice?.Scale_horizontally,
          'iframe--preserve-ratio': slice?.Preserve_ratio,
        }"
        :src="getValidUrl(slice?.Source)"
        :height="slice?.Height_in_px || 450"
        :width="slice?.Width_in_px || 600"
        frameborder="0"
        allowfullscreen
        aria-hidden="false"
        tabindex="0"
        :style="{
          '--height': `${slice?.Height_in_px || 450}`,
          '--width': `${slice?.Width_in_px || 600}`,
          'height': slice?.Preserve_ratio ? `auto` : `${slice?.Height_in_px || 450}px`,
          'width': slice?.Scale_horizontally ? `100%` : `${slice?.Width_in_px || 600}px`,
        }"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const getValidUrl = (url?: string): string => {
  if (!url) return ''

  try {
    new URL(url)
    return url
  }
  catch {
    return ''
  }
}
</script>

<style>
.iframe {
  display: block;
  max-width: 100%;
}

.iframe--preserve-ratio {
  aspect-ratio: auto var(--width) / var(--height);
}
</style>
